import { createSlice } from "@reduxjs/toolkit";

// Filtros de la navegabilidad de planes de terapia del terapeuta. Se ve solo
// lo del propio terapeuta, asi que el unico filtro es el participante; la
// lista sale de sus propias terapias.
const initialState = {
    filters: {
        member: "",
    },
    results: [],
}

export const therapyPlanTherapistSearchSlice = createSlice({
    name: "therapyPlanTherapistSearch",
    initialState,
    reducers: {
        setValue: (state, action) => {
            const { name, value } = action.payload;

            state.filters[name] = value;
        },
        setResults: (state, action) => {
            state.results = action.payload;
        },
    },
});

export const { setValue, setResults } = therapyPlanTherapistSearchSlice.actions;
export default therapyPlanTherapistSearchSlice.reducer;